import LogicaAPI from "./logicaapi";

class WebPage extends LogicaAPI {
  async getPage(path) {
    const res = await this.post("/api/v1/page", {
      body: {
        site_id: this.config.appId,
        path,
        type: "content",
      },
    });
    return res;
  }
}

export default WebPage;
